'use client';
import React, { useEffect } from 'react';
import { Button } from '@pezeshk-book/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { UsersActions } from '@store/users/users-action';

const pagination = ({ buttonTitle }: {buttonTitle: string}) => {
  const dispatch = useDispatch();
  const { paginationLoading, lastPage, currentPage } = useSelector((state: RootState) => state.users);

  //TODO: We don't need SWR right now but in the future it might come in handy

  /* const response = async () => {
     const res = await getUsersFromAPI({ page: 1, limit: 10, sort: 'id' });
     return res?.data;
   };
   const { data, error } = useSWR('users/datatable', response, {
     fallback: {
       'users/datatable': usersInfo,
     },
   }); */

  const paginationHandler = () => {
    dispatch(UsersActions.getExtendedUsers());
  };

  useEffect(() => () => {
    dispatch(UsersActions.resetFilterItems());
  }, []);

  if (lastPage > currentPage || !currentPage) {
    return (
      <Button loading={paginationLoading} disabled={paginationLoading} onClick={paginationHandler} className={'w-40 mt-12 my-32 self-end'} color={'primary'}>
        {buttonTitle}
      </Button>
    );
  }

  return null;
};

export default pagination;
